<template>
    <div v-if="visible" class="festival-container" @click="handleClose">
        <div class="festival-box">
            <img :src="config.fileUrl" alt="" class="content" @click.stop="handleDetial">
            <img src="../../assets/closetwo.png" class="icon-close" alt="" @click.stop="handleClose">
        </div>
    </div>
</template>

<script>
import { getOnShelfActivity } from '@/api/activity'
export default {
    data() {
        return {
            visible: false,
            activityStorageKey: 'finished-activity-list',
            config: {}
        }
    },

    methods: {
        async activate() {
            const res = await getOnShelfActivity({
                platform: 1, // 发薪PC
                type: 0 // 首页弹窗
            })

            const activityList = []
            const finishedActivityString = window.localStorage.getItem(this.activityStorageKey)
            const finishedActivity = finishedActivityString ? JSON.parse(finishedActivityString) : []
            const newFinishedActivity = []

            res?.forEach(item => {
                item.details?.forEach(sub => {
                    const key = `${item.activityId}>${sub.id}`
                    if (finishedActivity.includes(key)) {
                        newFinishedActivity.push(key)
                    } else {
                        activityList.push({
                            activityId: item.activityId,
                            name: item.name,
                            coverFileUrl: item.coverFileUrl,
                            ...sub
                        })
                    }
                })
            })

            this.config = activityList[0] || ''
            // 这里可以根据需要处理活动数据，例如显示活动信息或执行其他操作..

            window.localStorage.setItem(this.activityStorageKey, JSON.stringify(newFinishedActivity))
            //
            this.config.id && this.handleOpen()
        },
        handleClose() {
            const finishedActivityString = window.localStorage.getItem(this.activityStorageKey)
            const finishedActivity = finishedActivityString ? JSON.parse(finishedActivityString) : []
            finishedActivity.push(`${this.config.activityId}>${this.config.id}`)
            window.localStorage.setItem(this.activityStorageKey, JSON.stringify(finishedActivity))
            this.visible = false
        },
        handleOpen() {
            this.visible = true
        },
        handleDetial() {
            console.log('跳转详情')
        }
    }
}
</script>

<style lang="stylus" scoped>
.festival-container
    position fixed
    left 0
    top 0
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.7)
    z-index 3001
.festival-box
    width 600px

    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)

    display flex
    flex-direction column
    align-items center
    justify-content center

.content
    width 100%
    text-align center
.icon-close
    position absolute
    top 20px
    right -56px
    width 36px
    height 36px
    cursor pointer
</style>
